import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import balancesCtx from 'context/balances';
import floatToText from 'lib/float-to-text';

const BalanceDisplay = ({ label = '', className = '' }) => {
	const { balances } = useContext(balancesCtx);

	const balanceText = balances && balances[0] ? floatToText(balances[0].balance, { append: ' USD' }) : '';

	// Without a label (e.g. the desktop header, whose own visibility timer governs
	// this), keep the original behaviour of rendering nothing until the amount is known.
	// With a label, always render the block so its width stays reserved and neighbouring
	// elements (e.g. the mobile exchange switcher) don't shift while the amount reloads —
	// only the amount is hidden, the label stays put.
	if (!label && !balanceText) {
		return null;
	}

	let labelNode;
	if (label) {
		labelNode = <span className="text-xs text-gray-400 leading-none">{label}</span>;
	}
	const amountText = balanceText || '\u00A0';

	return (
		<div className={clsx('flex flex-col', className)}>
			{labelNode}
			<span className="text-blue-400 font-bold">{amountText}</span>
		</div>
	);
};

BalanceDisplay.propTypes = {
	label: PropTypes.string,
	className: PropTypes.string,
};

export default BalanceDisplay;
